import Decimal from 'decimal.js';

const divide = (first: number | string, second: number | string): number => {
  const firstDecimal = new Decimal(first);
  const secomdDecimal = new Decimal(second);

  return firstDecimal.div(secomdDecimal).toNumber();
};

const multiplication = (
  first: number | string,
  second: number | string,
): number => {
  const firstDecimal = new Decimal(first);
  const secomdDecimal = new Decimal(second);

  return firstDecimal.mul(secomdDecimal).toNumber();
};

const minus = (first: number | string, second: number | string): number => {
  const firstDecimal = new Decimal(first);
  const secomdDecimal = new Decimal(second);

  return firstDecimal.minus(secomdDecimal).toNumber();
};

const plus = (first: number | string, second: number | string): number => {
  const firstDecimal = new Decimal(first);
  const secomdDecimal = new Decimal(second);

  return firstDecimal.plus(secomdDecimal).toNumber();
};

export { divide, minus, multiplication, plus };
